import { CustomerList } from "@/components/CustomerList";

export const Customers: React.FC = () => {
  return (
   <CustomerList />
  )
}
